import {Card, DatePicker, DatePickerProps, Select} from "antd";
import {useAppDispatch} from "../../../../redux/store";
import styles from './blockTwoSettings.module.sass'
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import dateIcon from "../../../../assets/datePickerIcon.svg";
import closeIcon from "../../../../assets/close.svg";
import React from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import updateLocale from "dayjs/plugin/updateLocale";
import {citiesSF, levels, marketsSF} from "../../../../common/optionsForSkuFood";
import {RangePickerProps} from "antd/es/date-picker";
import {
    changeCityCFAC,
    changeCitySvTabAC,
    changeDateCFAC, changeDateSvTableAC,
    changeLevelCFAC,
    changeSpmCFAC, changeSpmSvTabAC
} from "../../../../redux/categoryFoodReducer";
import {changeTimeValue, zoomAC} from "../../../../redux/optionsReducer";

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(updateLocale);
dayjs.updateLocale('zh-cn', {
    weekStart: 1,
});

// Тип пропсов для компонента: параметры фильтрации для блока 2
type BlockTwoSettingsPropsType = {
    date: string[]
    city: string
    store_name: string
}

export const BlockTwoSettings = ({date, city, store_name}: BlockTwoSettingsPropsType) => {

    // Деструктуризация компонента RangePicker из DatePicker
    const {RangePicker} = DatePicker;

    // Инициализация dispatch для отправки экшенов в Redux
    const dispatch = useAppDispatch()

    // Кастомный формат для отображения диапазона дат
    const customFormat = (value: any) => {
        return value.format("YYYY-MM-DD ");
    }

    // Обработчик изменения диапазона дат: обновляет дату в Redux store
    const onChange = (
        value: DatePickerProps['value'] | RangePickerProps['value'],
        dateString: [string, string] | string,
    ) => {
        const start = dayjs(dayjs(dateString[0]).day(1).subtract(0, 'day')).format('YYYY-MM-DD')
        const end = dayjs(dayjs(dateString[1]).day(7).add(1, 'hour')).format('YYYY-MM-DD')       // настройка на один день

        dispatch(changeDateSvTableAC([start, end]))
    };

    // Формирование опций для селекторов городов и маркетов
    const cityOptions = citiesSF.map((el) => ({label: el, value: el}))
    const marketsOptions = marketsSF.map((el) => ({label: el, value: el}))

    // Отрисовка карточки с фильтрами: неделя, город, маркет
    return (
        <Card className={styles.card}>
            <div className={styles.content}>
                {/* Выбор диапазона недель */}
                <RangePicker defaultValue={[dayjs(date[0]), dayjs(date[1])]}
                             style={{maxWidth: '320px'}}
                             picker={'week'}
                             value={[dayjs(date[0]), dayjs(date[1])]}
                             locale={locale}
                             suffixIcon={<img src={dateIcon} alt={'select'}/>}
                             allowClear={{
                                 clearIcon: <img className={styles.closeIcon} src={closeIcon} alt={'clear'}/>
                             }}
                             format={customFormat}
                             onChange={onChange}
                />
                {/* Выбор города */}
                <Select placeholder={'Город'} options={cityOptions} value={city} className={styles.select}
                        onChange={(value: string) => dispatch(changeCitySvTabAC(value))}/>
                {/* Выбор маркета */}
                <Select placeholder={'Маркет'} options={marketsOptions} value={store_name} className={styles.select}
                        onChange={(value: string) => dispatch(changeSpmSvTabAC(value))}/>
            </div>
        </Card>
    );
};
